import { Box, Stack, Typography, Rating } from "@mui/material";
import {Link} from "react-router-dom";
import { useState } from "react";

export default function ReviewsCard({ data }) {
    const {
        icon = 'Image',
        id = 'id',
        rating = 4,
        title = "Untitled Review",
        comment = "No comment provided.",
        reviewer = "Anonymous",
        date = "Unknown Date",
    } = data || {};

    const [value, setValue] = useState(false);

const toggleReadMore = () => {
  setValue(!value);
};

let previewText;

if (comment.length > 120 && !value) {
  previewText = comment.slice(0, 120) + '...';
} else {
  previewText = comment;
}

    return (
        <Box border="1px solid #ED1C24" borderRadius={2} overflow="hidden" 
             sx={{
                height: '100%', 
                  display: 'flex',
                  flexDirection: 'column',
                justifyContent: 'space-between',
                }}>
            {/*<Box component="img" src={person} width={1} height={200} objectFit="cover" />*/}
            <Box p={2}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Rating name="read-only" value={rating} precision={0.5} readOnly size="small" />
                    <Typography variant="body2" color="text.secondary">
                        {rating.toFixed(1)} / 5
                    </Typography>
                </Stack>

                <Typography component="h3" color="#262262"
                    fontSize={{ xs: 14, md: 18 }}
                    fontWeight={500}
                    lineHeight={1.2}
                    mb={1}
                >
                    {title}
                </Typography>

                <Typography color="#77829D" fontWeight={400} fontSize={{ xs: 12, md: 14 }} mb={2} > {previewText} {comment.length > 120 && (
            <span onClick={toggleReadMore}style={{  color: "#1976d2",  cursor: "pointer",  marginLeft: "5px",fontWeight: 500,}}>
               {value ? "Read Less" : "Read More"}</span>)}
               </Typography>


               
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box component="img" src={icon} height={32} width={32} borderRadius="50%" sx={{ objectFit: "cover" }} />
                    <Box>
                        <Typography color="#262262" fontSize={{ xs: 12, md: 14 }} fontWeight={500}>
                            {reviewer}
                        </Typography>
                        <Typography color="#77829D" fontSize={{ xs: 10, md: 12 }}>
                            {date}
                        </Typography>
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
}
